import React from 'react';
import { TextField } from 'material-ui';
import SteelCompass from 'services/SteelCompass';
import { CourseActions, PageModuleActions, SettingsActions } from 'actions';
import { CourseStore, SettingsStore } from 'stores';
import Message from 'services/Message';
import PageModule from 'components/PageModule';
import { mixin, RefluxMixin } from 'Util';

const styles = {
  root: {
    background: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 40,
  },
  iframe: {
    border: '0',
    height: '75vh',
    width: '100%',
  }
};

class QuizIframeModule extends mixin(
  RefluxMixin,
  PageModule
) {
  constructor(props) {
    super(props);

    const { params: { caption } } = props;
    const initUrl = !caption ? 'https://quiztaker.s.coursio.com' : caption.main;

    this.state = {
      url: initUrl,
      hash: ''
    }
  }

  componentDidMount() {
    CourseActions.findById(this.props.courseId);
    SettingsActions.read();
  }

  listenToStores() {
    this.listenToStore(CourseStore);
    this.listenToStore(SettingsStore);
  }

  listenToActions() {
    this.listenToAction(SettingsActions.readComplete, (data) => {
      this.setState({ language: data.language });
    });
  }

  handleChange(e) {
    this.setState({ url: e.target.value });
  }

  saveUrl() {
    const { moduleId } = this.props;
    const { url } = this.state;

    CourseActions.updatePageModule(moduleId, {
      id: moduleId,
      params: {
        caption: {
          main: url
        }
      },
    });

    Message.info(this.context.getIntlMessage('video.changesSaved'));
  }

  changeToDetailMode() {
    this.saveUrl();
    this.onDetail();
    if (this.props.onDetail) {
      this.props.onDetail();
    }
    PageModuleActions.changePageModuleMode(this.props.moduleId, 'detail');
  }

  getUserHash() {
    const userId = this.props.user.id;

    SteelCompass.issueCdk(userId).then(
      response => {
        if (response && response[0].hash) {
          const { hash } = response[0];

          this.setState({ hash });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  renderIframe() {
    const { url, hash, course, language } = this.state;
    const lang = (typeof language !== 'undefined') ? language : 'en_US';
    const { courseSlug, themeColor } = this.props;
    const courseOwner = course.ownerSlug;

    if (!hash.length) {
      this.getUserHash();
      return <h2>Loading...</h2>;
    }

    if (!url) {
      return <h2>Please provide a valid URL</h2>;
    }

    const iframeUrl =
      url +
      '?hash=' + hash +
      '&lang=' + lang +
      '&themeColor=' + themeColor +
      '&courseSlug=' + courseSlug +
      '&courseOwner=' + courseOwner;

    return (
      <iframe
        title="Quiztaker app"
        width="560"
        height="315"
        style={styles.iframe}
        src={iframeUrl}>
      </iframe>
    );
  }

  renderEditMode() {
    const { ...other } = this.props;
    const { url } = this.state;

    return (
      <div {...other} style={styles.root}>
        <TextField
          hintText={'Iframe URL...'}
          value={url}
          onChange={::this.handleChange}
          onBlur={::this.saveUrl}
        />
      </div>
    );
  }

  renderDetailMode() {
    const { ...other } = this.props;
    const { url, hash } = this.state;

    if (!this.props.editor) {
      return this.renderIframe();
    }

    return (
      <div {...other} style={styles.root}>
        <p><i>If the course contains a quiz, it will automatically be shown here while in readerMode</i></p>
      </div>
    );
  }
}

export default QuizIframeModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/QuizIframe.js